import { render, staticRenderFns } from "./SubirDocumentos.vue?vue&type=template&id=36c20d0e&scoped=true&"
import script from "./SubirDocumentos.vue?vue&type=script&lang=js&"
export * from "./SubirDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./SubirDocumentos.vue?vue&type=style&index=0&id=36c20d0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c20d0e",
  null
  
)

export default component.exports